var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuildingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 0H16C17.8856 0 18.8284 0 19.4142 0.585786C20 1.17157 20 2.11438 20 4V19.25H21C21.4142 19.25 21.75 19.5858 21.75 20C21.75 20.4142 21.4142 20.75 21 20.75H1C0.585786 20.75 0.25 20.4142 0.25 20C0.25 19.5858 0.585786 19.25 1 19.25H2V7C2 5.11438 2 4.17157 2.58579 3.58579C3.17157 3 4.11438 3 6 3H10C11.8856 3 12.8284 3 13.4142 3.58579C14 4.17157 14 5.11438 14 7V19.25H15.5V7L15.5 6.91051C15.5001 6.04488 15.5002 5.25121 15.4134 4.60559C15.3178 3.89462 15.0929 3.14317 14.4749 2.52513C13.8568 1.90708 13.1054 1.68219 12.3944 1.5866C11.7579 1.50102 10.9774 1.49991 10.126 1.49999C10.2103 1.11275 10.351 0.820586 10.5858 0.585786C11.1716 0 12.1144 0 14 0ZM4.25 6C4.25 5.58579 4.58579 5.25 5 5.25H11C11.4142 5.25 11.75 5.58579 11.75 6C11.75 6.41421 11.4142 6.75 11 6.75H5C4.58579 6.75 4.25 6.41421 4.25 6ZM4.25 9C4.25 8.58579 4.58579 8.25 5 8.25H11C11.4142 8.25 11.75 8.58579 11.75 9C11.75 9.41421 11.4142 9.75 11 9.75H5C4.58579 9.75 4.25 9.41421 4.25 9ZM4.25 12C4.25 11.5858 4.58579 11.25 5 11.25H11C11.4142 11.25 11.75 11.5858 11.75 12C11.75 12.4142 11.4142 12.75 11 12.75H5C4.58579 12.75 4.25 12.4142 4.25 12ZM8 16.25C8.41421 16.25 8.75 16.5858 8.75 17V19.25H7.25V17C7.25 16.5858 7.58579 16.25 8 16.25Z",
    fill: "#5D50C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingIcon);
export default __webpack_public_path__ + "static/media/BuildingIcon.3632f45bbf505fb38677994a1233620b.svg";
export { ForwardRef as ReactComponent };